import React, { Component } from "react"

import {
  HeadingInitial,
  HeadingSecondary,
  Paragraph,
  Section,
  Tagline,
} from "elements"

class History extends Component {
  render() {
    return (
      <div>
        <HeadingInitial>Our History</HeadingInitial>

        <Section>
          <Tagline>
            The history of Camps and Campers begins with the 1996 launch of
            Campstaff by camp professionals Chris “Bunkie” Roy and Eric Sasson.
          </Tagline>
          <Paragraph>
            Campstaff was the first staffing website solely devoted to summer
            camp jobs. Bunkie, the associate director of a prominent New England
            camp and Eric, the camp’s webmaster saw a increasing challenge in
            the form of job inquiry emails arriving via the camp’s website
            partially completed or lacking pertinent information.
          </Paragraph>
          <Paragraph>
            Campstaff was created to allow job seekers to fill out a single,
            detailed profile and selectively submit that profile via email to
            camps with matching needs. Campstaff also allowed camp directors to
            perform the same search for job applicants, giving a proactive
            online recruiting tool to camps for the first time.
          </Paragraph>
          <Paragraph>
            Both Camps and Job Seekers had the equal opportunity to evaluate one
            another before committing major time and effort. The results have
            been over 100,000 job matches via Campstaff at camps in 49 states
            (still working on Hawaii!)
          </Paragraph>
          <Paragraph>Fast forward to 2012…</Paragraph>
          {/*this should be a Quote*/}
          <Paragraph>
            When it came time to choose camps for his daughters, Bunkie called
            fellow camp directors for recommendations.
          </Paragraph>
          <Paragraph>
            Bunkie and Lynn Roy, developing specialty camps and living in
            Louisiana found himself frequently asked by friends for
            recommendations about specific camps. If he was unfamiliar with the
            camp or uncomfortable recommending it, Bunkie would offer
            alternative choices. When it came time to choose camps for his
            daughters, Bunkie called fellow camp directors for recommendations.
          </Paragraph>
          <Paragraph>
            Shortly after, when an inquiry about a special needs camps let
            Bunkie to call Eric and Debbie Sasson, currently a special needs
            camp directors, for input—the dots were connected and the obvious
            conclusion was reached that camp directors are the best resource for
            picking camps.
          </Paragraph>
          <Paragraph>
            The development of Camps and Campers began. First converting the
            lessons of Campstaff’s two-way searchable database and emailed
            profile system into a family appropriate system. Then adding the
            Camp Director Pick’s feature to give the searches something no other
            camp directory site was offering—recommendations from camp industry
            insiders, just like camp professionals have access to.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>Our Staff</HeadingSecondary>
          <Paragraph>
            Chris “Bunkie” Roy got his start in the camping profession in 1992
            as Staffing Director and later, Associate Director for Camp Walt
            Whitman (NH). In addition to developing Campstaff and
            CampstaffNurses, Bunkie also developed SAT based summer camp
            programs for The Princeton Review and Kaplan. He directed the
            start-up of The Wellsprings Camps as Executive Director and later
            directed Camp Mah-Kee-Nac for Boys (MA). Bunkie Camping Company
            currently develops start-up camps in the deep south. Bunkie served
            on the boards of CampGroup, LLC and the New York Section of the
            American Camp Association. He chaired the Business and Operations
            Program Committee for the Tri-State Camp Conference.
          </Paragraph>
          <Paragraph>
            Eric Sasson, before creating Campstaff, built the original website
            for Camp Walt Whitman. CampWalt.com was the third summer camp listed
            on yahoo.com (remember when webmasters had to submit their own sites
            for indexing?!?) Eric has over 30 years of camp experience, at some
            of the Northeast’s finest camps, including Camp Walt Whitman, Camp
            Wingate*Kirkland and Camp Mah-Kee-Nac. He and wife, Debbie are the
            founders and directors of Camp Akeela (VT). He has been a full time
            camp professional for 15 years and is an active member of the
            American Camp Association. Eric earned a Masters in Education from
            Harvard University. He has been a speaker at the Tri-State and
            National Camp Conferences.
          </Paragraph>
          <Paragraph>
            Lynn Roy has been a full-time camp professional for 12 years. Lynn
            came to camping with a sales and marketing background. She helped
            develop and direct start-up camps with The Princeton Review, Kaplan,
            and Aspen Education Group before directing Camp Mah-Kee-Nac for 7
            years. She has presented several times at the Tri-State Camp
            Conference on topics ranging from raising a family at camp to hiring
            medical staff. Lynn currently oversees the daily operation of
            Campstaff and CampstaffNurses staffing websites. Lynn and Bunkie met
            at camp. They have 3 daughters, two of whom started camp as 1 month
            olds.
          </Paragraph>
          <Paragraph>
            Debbie Sasson has been spending her summers at camp for more than 25
            years. She worked at an impressive variety of camp
            types—traditional, full-summer, all boys, religious, special needs
            and others and has held almost every job at camp. Debbie has a
            Doctorate in Clinical Psychology from Yeshiva University. She is a
            co-founder and full-time director of Camp Akeela, a position to
            which she brings extensive knowledge of the fields of child,
            adolescent and Family-Systems psychology. Debbie and Eric first met
            at a summer camp and now have 2 daughters at camp with them.
          </Paragraph>
        </Section>
      </div>
    )
  }
}

export default History



// WEBPACK FOOTER //
// ./src/scenes/About/pages/history.js